export const SET_FILTER = 'SET_FILTER';
export const SET_BUILDER = 'SET_BUILDER';
export const SET_PIPELINE = 'SET_PIPELINE';
export const CONTENT_DID_MOUNT = 'CONTENT_DID_MOUNT';
export const FILTER_OPEN = 'FILTER_OPEN';
export const FILTER_CLOSE = 'FILTER_CLOSE';
export const MENU_OPEN = 'MENU_OPEN';
export const MENU_CLOSE = 'MENU_CLOSE';
export const PIPELINE_OPEN = 'PIPELINE_OPEN';
export const PIPELINE_CLOSE = 'PIPELINE_CLOSE';
export const PIPELINE_SIDE = 'PIPELINE_SIDE';
export const PIPELINE_SAVED_SHOW_OWN = 'PIPELINE_SAVED_SHOW_OWN';
export const PIPELINE_SAVED_SHOW_COMMON = 'PIPELINE_SAVED_SHOW_COMMON';
